import { useNavigate } from 'react-router-dom'
import { Box, Grid, Typography, Button, useTheme, useMediaQuery, Container } from '@mui/material'

const Header = () => {
  const navigate = useNavigate()
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('md'))

  return (
    <Box
      component="section"
      id="home"
      className="hero-banner pad-60"
      sx={{
        py: { xs: 6, md: 10 },
        px: { xs: 2, md: 6 },
        pb: { xs: 8, md: 12 },
        position: 'relative',
        overflow: 'hidden',
        minHeight: { xs: 'auto' },
      }}
    >
      {/* CONDITIONAL IMAGE: desktop absolute, mobile below */}
      {!isMobile && (
        <Box
          component="img"
          src="/assets/document-templates/epoch-banner.svg"
          alt="Hero Banner"
          sx={{
            position: 'absolute',
            top: 80,
            right: 0,
            width: '50%',
            height: '100%',
            zIndex: 0,
          }}
        />
      )}

      <Container className="mobile-pl0" maxWidth="lg" sx={{ position: 'relative', zIndex: 1 }}>
        <Grid className="Banner-width" container spacing={4} alignItems="center">
          <Grid
            className="mt-3"
            item
            xs={12}
            md={6}
            sx={{ mt: isMobile ? 4 : 8, position: 'relative' }}
          >
            {/* Decorative image */}
            <Box
              component="img"
              src="/assets/document-templates/circule-vic-2.png"
              alt="thumb"
              sx={{
                position: 'absolute',
                top: -30,
                left: -30,
                width: 80,
              }}
            />

            {/* Heading and description */}
            <Box maxWidth="90%">
              <Typography
                className="mb-4 main_titel"
                variant="h1"
                sx={{ mb: 3, fontWeight: 600, lineHeight: 1.3 }}
              >
                Epoch7 - One Platform, Infinite <span>Possibilities</span>
              </Typography>

              <Typography variant="body1" sx={{ fontSize: 18, fontWeight: 500, mb: 4 }}>
                We empower organizations to build their own digital platform that streamlines
                communication, improves workflow, and enhances productivity.
              </Typography>

              <Button
                className="btn primary-btn banner-button pl-2"
                variant="contained"
                size="large"
                endIcon={
                  <Box
                    component="img"
                    src="/assets/document-templates/Arrow.svg"
                    alt="arrow icon"
                    sx={{ ml: 1 }}
                  />
                }
                onClick={() => navigate('/signup')}
                sx={{ textTransform: 'none' }}
              >
                Start Building Now
              </Button>
            </Box>

            {/* Mobile image shown below content only on mobile */}
            {isMobile && (
              <Box
                component="img"
                src="/assets/document-templates/epoch-banner.svg"
                alt="Hero Banner Mobile"
                sx={{
                  width: '100%',
                  height: 'auto',
                  mt: 4,
                }}
              />
            )}
          </Grid>
        </Grid>
      </Container>
    </Box>
  )
}

export default Header
